/* Exclusive upsell cart linkage: whenever the cart drawer finishes refreshing
   (theme:cart:added — fired after add/remove/quantity changes), check for any
   exclusive-upsell child line (tagged with data-exclusive-upsell-parent, set
   from the _exclusive_upsell_parent line item property) whose parent variant
   is no longer present in the cart, and remove it by clicking its own remove
   button. This reuses the theme's existing remove flow instead of calling the
   cart API directly, so it stays correct even after the drawer DOM is rebuilt. */
(function () {
  function removeOrphanedUpsellChildren() {
    var items = document.querySelectorAll('[data-cart-item]');
    if (!items.length) return;

    var presentVariantIds = {};
    items.forEach(function (item) {
      var variantId = item.getAttribute('data-variant-id');
      if (variantId) presentVariantIds[variantId] = true;
    });

    items.forEach(function (item) {
      var parentVariantId = item.getAttribute('data-exclusive-upsell-parent');
      if (!parentVariantId || presentVariantIds[parentVariantId]) return;

      var removeBtn = item.querySelector('[data-item-remove]');
      if (removeBtn) removeBtn.click();
    });
  }

  document.addEventListener('DOMContentLoaded', removeOrphanedUpsellChildren);
  document.addEventListener('theme:cart:added', removeOrphanedUpsellChildren);
})();
